// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + {"vendors-node_modules_atlas_ui_build_styles_css":"5f12b68f16a1a58423d8","src_modules_share-css_js":"344d746d06ac88053398"}[chunkId] + "/index.css";
};